import { createApp } from 'vue';

let app = createApp({
    data() {
        return {
        }
    },
    mounted() {
    },
    computed: {
        overview() {
            return window.br.cart;
        }
    }
});

app.mount('#nav-cart');